import React from 'react';

//types
import { IIconRotatableProps } from 'assets/icons/IconProps';

export const ChevronUpIcon = ({
  width = 24,
  height = 24,
  rotate = 0,
  stroke = '#82878c',
  strokeWidth = 2,
  additionalStyle,
}: IIconRotatableProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
    style={additionalStyle}
  >
    <path
      transform={`rotate(${rotate} 12 12)`}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18 15l-6-6-6 6"
    />
  </svg>
);
